import React, { useEffect, useRef } from 'react';
import { useBOMStore } from 'src/hooks/bom';
import useReduxState from "../../../../hooks/useReduxState";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import AxiosIndicatorRunTimeLoader from "../../../../component/Global/AxiosIndicatorRunTimeLoader";
import AxiosSingletonLoader from "../../../../component/Global/AxiosSingletonLoader";
import stickyTableCommon from 'src/helper/stickyTableCommon';
import BOMRepository from 'src/repository/BOMRepository';
import System from 'src/helper/system';
import BomRemovePart from './BomRemovePart';

const BomMultipleMatchTable = (props) => {
    const [{ bom_detail_Multiple_list }] = useBOMStore();
    const [top, SetTop] = useReduxState({}, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT', true);
    const refLoadMore = useRef();
    const multipleListRecord = bom_detail_Multiple_list?.records
    const displayStatus = multipleListRecord && Object.keys(multipleListRecord).length > 0;
    const [__check] = useAxiosIndicatorCheck();

    useEffect(() => {
        if (multipleListRecord?.length > 0) {
            stickyTableCommon('bommultiplematch-table', null);
        }
    }, [bom_detail_Multiple_list, __check(['BOM_TAB_API_CALL', 'BOM_API_CALL']).status]);

    return (
        <>
            <div className="tab-content p-0">
                <div id='sticky-table-wrapper'
                    className={__check(['BOM_TAB_API_CALL', 'BOM_API_CALL']).status ?
                        "table-responsive loader-wrapper-outer minh350 mb-0" :
                        "table-responsive mb-0 sticky-table-wrapper"}>
                    {__check(['BOM_TAB_API_CALL', 'BOM_API_CALL'], { overlay: true }).render}
                    <table id='bommultiplematch-table' className="bs5 table table-bordered">
                        <thead style={{ display: displayStatus ? '' : 'none' }}>
                            <tr>
                                <th className="w-85"></th>
                                <th className="text-nowrap w200">Part Number</th>
                                <th className="text-nowrap w220">Manufacturer Part Number</th>
                                <th className="text-nowrap w150">Quantity</th>
                                <th className="text-nowrap minw220">Price</th>
                                <th className="text-nowrap w200">Availability</th>
                                <th className="text-nowrap">Manufacturer</th>
                                <th className="text-nowrap">Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayStatus && Object.entries(multipleListRecord).map(([key, record]) => (
                                <tr className="align-top" key={key}>
                                    <td>
                                        <span className="index-count">{record.sequenceNumber}</span>
                                    </td>
                                    {!record.isDeleted ? (
                                        <>
                                            <td>
                                                <div className="d-flex w-100 justify-content-between align-items-center">
                                                    <div className="form-control form-control-sm"><span className='mt-1 d-block text-nowrap'>{record.partNumber}
                                                    </span></div>
                                                    <BomRemovePart bomId={record.bomId} bomDetailId={record.bomDetailId} removeType={"multipleMatches"} removePartNumber={record.partNumber}/>
                                                </div>
                                            </td>
                                            <td className='loader-wrapper-outer-sm'>
                                                <AxiosSingletonLoader overlay={true}
                                                    customAxiosIndicatorRunTimeLoader={() => (
                                                        <AxiosIndicatorRunTimeLoader overlay={true} />
                                                    )}
                                                    slugKey={['BOM_MULTIPLE_MATCH_PRODUCT_SEARCH', 'PRODUCT_INVENTORY_API_CALL']}>
                                                    <a href={void (0)} className="text-blue2 mt-2 d-block"
                                                        onClick={() => System.popup('BomSearchMatchPopup', { single_bom: record, bomDetailId: record.bomDetailId })}>
                                                        {record.productMatchCount} possible matches (choose)
                                                    </a>
                                                </AxiosSingletonLoader>
                                            </td>
                                            <td>
                                                <div className="form-control form-control-sm"><span className='mt-1 d-block'>{record.quantity}
                                                </span></div>
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </>
                                    ) : (
                                        <>
                                            <td>Deleted: {record.manufacturerPartNumber}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {displayStatus && Object.entries(multipleListRecord).length < (bom_detail_Multiple_list?.count + bom_detail_Multiple_list?.deleted) &&
                <div className="pagination-row text-center"
                    style={__check(['BOM_TAB_API_CALL', 'BOM_API_CALL', 'CART_API_CALL']).status ? { display: 'none' } : {}}>
                    <button ref={refLoadMore} onClick={() => SetTop(BOMRepository.loadMore(top, props))}
                        className="bs5 m-t-30 m-b-30 btn btn-secondary w155">
                        Load More
                    </button>
                </div>
            }
            {!(displayStatus && Object.entries(multipleListRecord).length < bom_detail_Multiple_list?.count) &&
                <div className="pagination-row text-center"></div>
            }
        </>
    );
};

export default BomMultipleMatchTable;
